var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedUser)?_c(_vm.isAdmin ? 'AdminDashboard' : 'UserDashboard',{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }